import type { JSX } from 'react'

import { Icon, IconNames } from 'atoms/Icon'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { COLOR } from 'vars/index'
import { ContentStateBadgeKind } from './ContentStateBadge.h'
import { ContentStateBadgeSC } from './ContentStateBadge.styled'

const iconByKind: Record<ContentStateBadgeKind, IconNames> = {
  PIN_LOCK: IconNames.tvPinLock,
  GEOBLOCK: IconNames.geoblock,
}

export interface IContentStateBadgeProps {
  kind: ContentStateBadgeKind
}

export const ContentStateBadge = ({
  kind,
}: IContentStateBadgeProps): JSX.Element => (
  <ContentStateBadgeSC data-testid='content-state-badge' data-kind={kind}>
    <Icon
      name={iconByKind[kind]}
      color={
        kind === ContentStateBadgeKind.PIN_LOCK
          ? COLOR.DISABLED
          : Colors.TEXT_ICON_PRIMARY
      }
      size={null}
    />
  </ContentStateBadgeSC>
)
